const server = 'https://cycly.onrender.com'

export default server